import script from "./IdentityBinding.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentityBinding.vue?vue&type=script&setup=true&lang=js"

import "./IdentityBinding.vue?vue&type=style&index=0&id=0882ac78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0882ac78"]])

export default __exports__